import { useContext, useEffect, useState } from 'react'
import "./style.scss"
import Input from '../../Input';
import { AuthContext } from '../../../context/auth';
import { addAdminUserApi, updateAdminUserApi, requestTokenAdminUserApi, assignRoleToUserApi, getRolesApi } from '../../../api';
import Dropdown from '../../Dropdown';
const Index = ({ setOpenAdminModal, selectedAdmin, setSelectedAdmin, fetchAdmins, setDeleteAdminModal, setChangePasswordModal, setToken }) => {
  const { setNotification, setIsLoading, isLoading } = useContext(AuthContext)
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [role, setRole] = useState('')
  const [roles, setRoles] = useState([])
  const [roleDropDownDisabled, setRoleDropDownDisabled] = useState(false)

  const emailRegex = /^[\w+.-]+@[\w.-]+\.\w{2,3}$/;

  const getRoles = () => {
    setIsLoading(true)
    getRolesApi().then(res => {
      if (res && res.data) {
        setIsLoading(false)
        const roles = res?.data?.roles || []
        const superadmin = {
          id: '1',
          name: 'Super Admin',
        }
        setRoles([superadmin, ...roles?.map(role => ({ id: role?.id, name: role?.name }))])
      }
    }).catch(err => {
      setIsLoading(false)
    })
  }

  useEffect(() => {
    if (selectedAdmin) {
      setFirstName(selectedAdmin.first_name)
      setLastName(selectedAdmin.last_name)
      setEmail(selectedAdmin.email)
    }
    getRoles()
  }, [selectedAdmin])

  const isDisabled = () => {
    if (selectedAdmin) {
      return (isLoading || !firstName || !lastName)
    }
    return (isLoading || !firstName || !lastName || !email || !emailRegex.test(email) || !password || !role || roleDropDownDisabled)
  }

  const editAdmin = () => {
    setIsLoading(true)
    const data = {
      first_name: firstName,
      last_name: lastName,
      position: '',
      is_email_verified: false
    }
    updateAdminUserApi(selectedAdmin.id, data).then(() => {
      fetchAdmins()
      setIsLoading(false)
      setOpenAdminModal(false)
      setSelectedAdmin(null)
      setNotification({
        message: "Admin user Updated.",
        type: "update"
      })
    }).catch(err => {
      setIsLoading(false)
      setNotification({
        message: "Something went wrong.",
        type: "red"
      })
    })
  }

  const addAdmin = () => {
    setIsLoading(true)
    const data = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      password: password
    }
    addAdminUserApi(data).then((user) => {
      console.log(user)
      assignRoleToUserApi(role?.id, user?.data?.user?.id).then(res => {
        if (res && res.data) {
          fetchAdmins()
          setIsLoading(false)
          setOpenAdminModal(false)
          setSelectedAdmin(null)
          setNotification({
            message: "Admin Added.",
            type: "success"
          })
        }
      }).catch(err => {
        setIsLoading(false)
        setNotification({ type: 'error', message: 'Something went wrong in assigning role' })
      })
    }).catch(err => {
      setIsLoading(false)
      setNotification({
        message: "Something went wrong.",
        type: "red"
      })
    })
  }

  const requestPasswordChange = () => {
    setIsLoading(true)
    requestTokenAdminUserApi({
      email: email
    }).then((res) => {
      if (res?.data?.token) {
        setToken(res.data.token)
        setChangePasswordModal(true)
        setIsLoading(false)
      }
    }).catch(err => {
      setIsLoading(false)
      setNotification({
        message: "Something went wrong.",
        type: "red"
      })
      setToken(null)
    })
  }


  return (
    <div className="small-modal-wrapper">
      <div className="small-modal-content">
        <span className='close' onClick={() => {
          setOpenAdminModal(false)
          setSelectedAdmin(null)
        }}><i className="fas fa-times"></i></span>
        {selectedAdmin && <span className='delete' onClick={() => {
          setDeleteAdminModal(true)
        }}>
          <i className="fal fa-trash-alt"></i></span>}
        <h2>{selectedAdmin ? `Edit ${selectedAdmin.first_name ? selectedAdmin.first_name + " " + selectedAdmin.last_name : 'Admin User'}` : 'Add New Admin'}</h2>
        <div className="form-container">
          <div className='row'>
            <div className="input-container">
              <label htmlFor="first name">First Name<span>*</span></label>
              <Input type='text' placeholder='First Name' value={firstName} onChange={e => setFirstName(e.target.value)} />
            </div>
            <div className="input-container">
              <label htmlFor="last name">Last Name</label>
              <Input type='text' placeholder='Last Name' value={lastName} onChange={e => setLastName(e.target.value)} />
            </div>
          </div>
          <div className="row">
            <div className="input-container">
              <label htmlFor="email">Email<span>*</span></label>
              <Input type='text' placeholder='Email' value={email} onChange={e => setEmail(e.target.value)} isDisabled={selectedAdmin} />
            </div>
            {!selectedAdmin &&
              <div className="input-container">
                <label htmlFor="password">Password<span>*</span></label>
                <Input type='password' placeholder='password' value={password} onChange={e => setPassword(e.target.value)} />
              </div>
            }
          </div>
          {!selectedAdmin && !!roles.length &&
            <div className="row">
              <div className="input-container">
                <label htmlFor="role">Select Role<span>*</span></label>
                <Dropdown label="Select Role" options={roles} value={role} onChange={(value) => setRole(value)} setIsDisabled={setRoleDropDownDisabled} className={'dropdown'} optionType={'role'} />
              </div>
            </div>
          }
        </div>
        <div className='row'>
          {selectedAdmin &&
            <button className='btn password-btn'
              onClick={requestPasswordChange}>Change Password</button>
          }
          <button className='btn add-btn'
            disabled={isDisabled()}
            onClick={() => {
              if (selectedAdmin) {
                editAdmin()
              } else {
                addAdmin()
              }
            }}>{selectedAdmin ? 'Save Changes' : 'Add New Member'}</button>
        </div>
      </div>
    </div>
  )
}

export default Index